import { shortFormsEnabled } from '../../../brand/tenant';
import { PAYMENT_TYPES_CREDIT_INVOICE, PAYMENT_TYPES_OPTIONS } from '../../../constants';

// Ð£ ÑÐµÑÑÑ Ð´Ð¸Ð»ÐµÑÐ¾Ð² Ð´Ð¾Ð¿. Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ñ Ð¸ ÑÑÐ»ÑÐ³ Ð½ÐµÑ: ÑÐ´ÐµÐ»ÐºÐ° Ð¸Ð´ÑÑ Ñ Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¸
// ÑÑÐ°Ð·Ñ Ðº Ð°Ð½ÐºÐµÑÐµ Ð¸Ð»Ð¸ Ð¾Ð¿Ð»Ð°ÑÐµ.
export const EXTRA_STEP_TITLES = ['ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ', 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸'];

export const withoutExtraSteps = (steps, short = shortFormsEnabled()) =>
  short ? steps.filter((step) => !EXTRA_STEP_TITLES.includes(step.title)) : steps;

// Ð¨Ð°Ð³Ð¸ 2 Ð¸ 3 Ð¾ÑÑÐ°ÑÑÑÑ Ð² Ð½ÑÐ¼ÐµÑÐ°ÑÐ¸Ð¸ ÑÐ´ÐµÐ»ÐºÐ¸ (Ð½Ð° Ð½Ð¸Ñ Ð·Ð°Ð²ÑÐ·Ð°Ð½ Ð±ÑÐº), Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÐºÑÐ°Ð½
// Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼, Ð° Ð¿ÑÐ¾ÑÐ¾Ð´Ð¸Ð¼ Ð½Ð°ÑÐºÐ²Ð¾Ð·Ñ â ÐºÐ°Ðº Â«Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑÂ» Ñ Ð¿ÑÑÑÑÐ¼ ÑÐ¿Ð¸ÑÐºÐ¾Ð¼.
export const shouldSkipExtras = ({ short = shortFormsEnabled(), step, ordersCount, loading }) =>
  Boolean(short) && (step === 2 || step === 3) && ordersCount > 0 && !loading;

// ÐÑÐ´Ð° Ð²ÐµÐ´ÑÑ Â«ÐÐ°Ð·Ð°Ð´Â» Ñ Ð°Ð½ÐºÐµÑÑ Ð¸Ð»Ð¸ Ð¾Ð¿Ð»Ð°ÑÑ.
export const stepBeforePayment = (short = shortFormsEnabled()) => (short ? 1 : 311);

// Ð¡ÐµÑÑÐµ Ð´Ð¸Ð»ÐµÑÑ Ð¿ÑÐ¾Ð´Ð°ÑÑ Ð² ÐºÑÐµÐ´Ð¸Ñ: Â«ÐÐ²ÑÐ¾ÐºÑÐµÐ´Ð¸ÑÂ» Ð²ÑÐ±ÑÐ°Ð½ ÑÑÐ°Ð·Ñ, Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð¾ÑÑÐ°ÑÑÑÑ ÐºÐ»Ð¸ÐµÐ½Ñ Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ.
export const defaultPaymentOption = (short = shortFormsEnabled()) =>
  short ? PAYMENT_TYPES_OPTIONS.find((option) => option.value === PAYMENT_TYPES_CREDIT_INVOICE) : null;
